import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";

// Pages — admin-only closed system
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";

// Public landing — self-service assessment request
import RequestAssessment from "./pages/RequestAssessment";

// Guest Assessment Pages — invitation-based, no login required
import GuestAssessment from "./pages/GuestAssessment";
import GuestThankYou from "./pages/GuestThankYou";

function AppRoutes() {
  return (
    <Routes>
      {/* Root redirects to admin login */}
      <Route path="/" element={<Navigate to="/admin" replace />} />

      {/* Legal Pages */}
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/cookies" element={<CookiePolicy />} />

      {/* Public — prospects request an assessment link via this page */}
      <Route path="/request-assessment" element={<RequestAssessment />} />

      {/* Guest Assessment Routes (invitation-based, no auth) */}
      <Route path="/guest/:token" element={<GuestAssessment />} />
      <Route path="/guest/thank-you" element={<GuestThankYou />} />

      {/* Admin Routes */}
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />

      {/* Legacy/public auth routes — system is now closed; redirect to admin login */}
      <Route path="/login" element={<Navigate to="/admin" replace />} />
      <Route path="/register" element={<Navigate to="/admin" replace />} />
      <Route path="/forgot-password" element={<Navigate to="/admin" replace />} />
      <Route path="/reset-password" element={<Navigate to="/admin" replace />} />
      <Route path="/dashboard" element={<Navigate to="/admin" replace />} />
      <Route path="/assessment/new" element={<Navigate to="/admin" replace />} />
      <Route path="/assessment/:id" element={<Navigate to="/admin" replace />} />
      <Route path="/results/:id" element={<Navigate to="/admin" replace />} />

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
